import React from 'react';
import { Card, Button, Alert } from '../ui';

const WebsiteForm = ({ error, loading, websiteUrlInput, setWebsiteUrlInput, onSubmit }) => {
  return (
    <div className='min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8'>
      <div className='max-w-md w-full space-y-8'>
        <div className='text-center'>
          <h1 className='text-3xl font-bold text-gray-900 mb-2'>MarketChef</h1>
          <p className='text-gray-600'>Social Media Management Platform</p>
        </div>
        <Card>
          <Card.Body>
            <div className='space-y-6'>
              <div>
                <h2 className='text-xl font-semibold text-gray-900 mb-2'>Welcome to MarketChef</h2>
                <p className='text-gray-600'>
                  Enter your website URL to get started with managing your social media accounts and
                  content.
                </p>
              </div>
              {error && <Alert variant='error'>{error}</Alert>}
              <form onSubmit={onSubmit} className='space-y-4'>
                <div>
                  <label
                    htmlFor='websiteUrl'
                    className='block text-sm font-medium text-gray-700 mb-2'
                  >
                    Website URL
                  </label>
                  <input
                    type='text'
                    id='websiteUrl'
                    value={websiteUrlInput}
                    onChange={(e) => setWebsiteUrlInput(e.target.value)}
                    placeholder='https://yourwebsite.com'
                    className='w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent'
                    required
                    disabled={loading}
                  />
                </div>
                <Button
                  type='submit'
                  variant='primary'
                  size='lg'
                  className='w-full'
                  loading={loading}
                  disabled={loading}
                >
                  {loading ? 'Activating...' : 'Start Setup'}
                </Button>
              </form>
              <div className='text-center'>
                <p className='text-sm text-gray-500'>
                  Don't have an access key?{' '}
                  <a href='#' className='text-primary-600 hover:text-primary-500'>
                    Contact support
                  </a>
                </p>
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default WebsiteForm;
